import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { TableHeader } from '@huge-monorepo/shared/interfaces';
@Component({
  selector: 'huge-monorepo-teltonika-select-tag-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule],
  templateUrl: './teltonika-select-tag-modal.component.html',
  styleUrl: './teltonika-select-tag-modal.component.scss',
})
export class TeltonikaSelectTagModalComponent {

  constructor(
    public dialogRef: MatDialogRef<TeltonikaSelectTagModalComponent>,
  ) { }

  selectedID: number = 0;

  index: number = 0;
  headers: TableHeader[] = [
    {
      ID: 'Name',
      Index: this.index++,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },

    {
      ID: 'Description',
      Index: this.index++,
      Sort: 'Description',
      Sortable: false,
      Text: 'Description',
      Type: String,
      Align: 'left',
    },
    // {
    //   ID: 'Devices',
    //   Index: this.index++,
    //   Sort: 'Devices',
    //   Sortable: false,
    //   Text: 'Devices',
    //   Type: String,
    //   Align: 'left',
    // },
    // {
    //   ID: 'CreatedAt',
    //   Index: this.index++,
    //   Sort: 'CreatedAt',
    //   Sortable: false,
    //   Text: 'Created At',
    //   Type: Date,
    //   Align: 'left',
    // },

  ];

  selected(e: any) {
    this.selectedID = e['ID'];
    this.closeDialog(true);
  }

  closeDialog(save: boolean): void {
    if (!save) {
      this.dialogRef.close(false);
      return;
    }

    this.dialogRef.close(this.selectedID);
  }
}
